// Readies the chosen interface language before the app renders: its catalogue,
// antd's own wording (pagination, empty tables, the date picker), dayjs's month
// and weekday names, and the page's direction. English needs only the direction.
//
// Each language is its own chunk, so a reader downloads only the one they use.
import dayjs from "dayjs";
import { findLanguage } from "./languages";
import { getStoredLanguage } from "./Metronici18n";
import { installTranslations } from "./translate";

const LOADERS = {
   ar: () =>
      Promise.all([
         import("./messages/ar.json"),
         import("antd/es/locale/ar_EG"),
         import("dayjs/locale/ar")
      ]),
   fr: () =>
      Promise.all([
         import("./messages/fr.json"),
         import("antd/es/locale/fr_FR"),
         import("dayjs/locale/fr")
      ]),
   es: () =>
      Promise.all([
         import("./messages/es.json"),
         import("antd/es/locale/es_ES"),
         import("dayjs/locale/es")
      ])
};

let antdLocale;
let latestRequest = 0;

/** antd's locale for the language shown; undefined for English, antd's default. */
export const getAntdLocale = () => antdLocale;

// Resolves to the language once it is in place, or to null when a later request
// overtook it while its files were loading.
async function install(language) {
   const request = ++latestRequest;
   const load = LOADERS[language.code];
   const [messages, antd] = load ? await load() : [];
   if (request !== latestRequest) return null;

   document.documentElement.lang = language.code;
   document.documentElement.dir = language.dir;
   installTranslations(language.code, messages?.default);
   antdLocale = antd?.default;
   dayjs.locale(load ? language.code : "en");
   return language;
}

export const loadTranslations = () => install(findLanguage(getStoredLanguage()));

/**
 * Shows another language without the reload `setLanguage` does, for the one screen whose
 * wording follows something other than the reader's choice: a public survey reads in the
 * survey's language. Wording computed before the switch stays as it was, so the caller
 * renders its screen again once this resolves.
 */
export const showLanguage = (code) => install(findLanguage(code));
